import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { QuotationButton } from '../../../../shared';
import { GetCommertialsConditionsResponse } from '../../../../../../../../shared/interfaces';
import { TheftInsurancePaymentMethodForm, TheftInsuranceQuotationForm } from './StepThreeFormProvider';
import { TheftInsuranceQuotationComponent, TheftInsuranceQuotationRequest, WebTheftInsuranceQuotation } from '../../../../../../../../shared/interfaces/services/theft-insurance-quotation-service';

interface StepThreeFormContextProps {
  stepThreeTheftInsuranceQuotationForm:       FormInstance<TheftInsuranceQuotationForm>;
  theftInsurancePaymentMethodsForm:           FormInstance<TheftInsurancePaymentMethodForm>;

  labelButton:                                QuotationButton;
  setLabelButton:                             Dispatch<SetStateAction<QuotationButton>>;

  quotationResponse?:                         WebTheftInsuranceQuotation | undefined;
  setQuotationResponse:                       Dispatch<SetStateAction<WebTheftInsuranceQuotation | undefined>>;

  commertialConditions:                       GetCommertialsConditionsResponse | undefined;
  clearPrimaFieldsOnFormChange:               () => void;

  generateTheftInsuranceQuotationForm:        () => TheftInsuranceQuotationRequest;

  theftInsuranceQuotationComponents:          Array<TheftInsuranceQuotationComponent>;

  handlerOnClick:                             () => Promise<void>;
  createTabs:                                 () => void;
  quotationTabs:                              any[];
  setQuotationTabs:                           React.Dispatch<React.SetStateAction<any[]>>
  activeTab:                                  any;
  setActiveTab:                               React.Dispatch<any>;
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
